import { render } from "./MatchCreationView.vue?vue&type=template&id=0f98af9f&ts=true"
import script from "./MatchCreationView.vue?vue&type=script&lang=ts"
export * from "./MatchCreationView.vue?vue&type=script&lang=ts"

import "./MatchCreationView.vue?vue&type=style&index=0&id=0f98af9f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__